import { render, staticRenderFns } from "./subdivisionsAdd.vue?vue&type=template&id=5dc21655&scoped=true&"
import script from "./subdivisionsAdd.vue?vue&type=script&lang=js&"
export * from "./subdivisionsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc21655",
  null
  
)

export default component.exports